<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Calendar</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
             </li>
             <li class="breadcrumb-item active">Calendar</li>
             <li class="breadcrumb-item">
                <router-link to="holidays">Calendar Event</router-link>
             </li>
          </ol>
       </nav>
       <hr style="margin-top:-10px"/>
       <div class="col-md-12">
          <full-calendar :event-sources="eventSources" :config="config"></full-calendar>
       </div>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      eventSources: [
        {
          events(start, end, timezone, callback) {
            axios
              .get(`api/calendar`)
              .then(response => {
                callback(response.data);
              });
          }
        }
      ],
      config: {
        locale: "en",
        defaultView: "month",
        editable: false,
        eventLimit: 4,
        eventLimit: true,
        eventRender: function(event, element) {
                if (event.type == 1) {
                    element.css({
                        "background-color": "#d19a02",
                        border: "none",
                        color: "#eee"
                    });
                } else if (event.type == 2) {
                    element.css({
                        "background-color": "#007bff",
                        border: "none",
                        color: "#fff"
                    });
                } else if (event.type == 3) { 
                    element.css({
                        "background-color": "#17a2b8",
                        border: "none",
                        color: "#000"
                    });
                } else if (event.type == 4) {
                    element.css({
                        "background-color": "#f9ff4a",
                        border: "none",
                        color: "#000"
                    });
                } else if (event.type == 5) {
                    element.css({
                        "background-color": "#dc3545",
                        border: "none",
                        color: "#fff"
                    });
                } else if (event.type == 6) {
                    element.css({
                        "background-color": "#70c2c2",
                        border: "none",
                        color: "#fff"
                    });
                } else if (event.type == 7) {
                    element.css({
                        "background-color": "#f9ff4a",
                        border: "none",
                        color: "#000"
                    });
                }else if (event.type == 8) {
                    element.css({
                        "background-color": "#ed0758",
                        border: "1px solid #f75c95",
                         color: "#fff"
                    });
                }else if (event.type == 9) {
                    element.css({
                        "background-color": "#3629c2",
                        border: "1px solid #685de3",
                        color: "#fff"
                    });
                }else if (event.type == 10) {
                    element.css({
                        "background-color": "#34eb46",
                        border: "1px solid #05a314",
                        color: "#fff"
                    });
                }
                else if (event.type == 12) {
                    element.css({
                        "background-color": "#facf32",
                        border: "1px solid #e6b810",
                        color: "#fff"
                    });
                }
            }
   
        }
    };
  }
};
</script>
<style>
  .fc-title{
    white-space: pre-line;
   }

    /* .fc-widget-header{
       background-color:#5a77ad;
       color:#fff;
     }

    .fc-sun{
       background-color:#5a77ad;
       color:#962020;
    }
    .fc-sat{
       background-color:#5a77ad;
       color:#962020;
    }
    .fc-future{
       background-color: #f1f1f1;
       color: #555;
    }

     .fc-past{
        background-color: #f1f1f1;
        color: #555;
    } 
    .fc-widget-header{
       background-color:blue;
       color:#fff;
     }
   .fc-sun{
       background-color:red;
       color:#fff;
   }
   .fc-sat{
       background-color:red;
       color:#fff;
   }
   .fc-future{
       background-color: #f1f1f1;
       color: #555;
   }
   .fc-past{
        background-color: #f1f1f1;
        color: #555;
   } */
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-calendar/todo-calendar.vue